import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";

const styles = createUseStyles(theme => ({
  changePolicyModal: {
    width: "480px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  modalContent: {
    margin: "20px 0 0 0",
    display: "grid",
    gap: "20px"
  },
  scrollableContainer: {
    maxHeight: "280px",
    overflowY: "scroll"
  },
  optionContainer:{
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
     justifyContent: "space-between",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px",
    marginBottom:"12px",
    "&:hover": {
      border: theme.modal.optionHover.border,
      "& input":{
        backgroundColor: theme.modal.optionHover.backgroundColor,
        border: theme.buttons.primary.border,
        "&:checked": {
          backgroundColor: theme.modal.backgroundColor,
          border: theme.modal.border,
          outline: theme.buttons.primary.border,
          borderColor: theme.modal.optionHover.backgroundColor
        }
      },
       "& input[type=\"radio\"]":{
       "&:checked": {
        backgroundColor: theme.modal.selectedOption.icon.stroke,
       }
      }
    },
    "& h3":{
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      color: colors.grey,
      margin: 0
    },
    "& p":{
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: colors.mediumGrey,
      margin: "0px"
    },
    "& input":{
      appearance: "none",
      width: "16px",
      height: "16px",
      border: "1px solid " + colors.lightGrey,
      borderRadius: "8px",
      cursor: "pointer",
      "&:checked": {
        backgroundColor: theme.modal.backgroundColor,
        border: theme.modal.border,
        outline: theme.buttons.primary.border,
        backgroundImage: "none",
      }
    },
    "& input[type=\"radio\"]":{
       "&:checked": {
        backgroundColor: theme.modal.selectedOption.icon.stroke,
       }
      }
  },
 selectedOptionContainer:{
    justifyContent: "space-between",
    border: theme.modal.selectedOption.border,
    backgroundColor: theme.modal.selectedOption.backgroundColor,
    color: theme.modal.selectedOption.text.color,
    padding: "15px",
    "&:hover": {
      border: theme.modal.selectedOption.border,
    },
    "& h3":{
      color: theme.modal.selectedOption.text.color,
    },
    "& p":{
      color: theme.modal.selectedOption.text.color,
    },
  },
  linkContainer: {
    "& a": {
      textDecoration: "none",
      color: theme.buttons.defaultLink.color,
      fontWeight: 600
    }
  },
  policyName: {
    color: colors.lightBlack
  },
  cancelBtnCol:{
    height: "44px"
  },
  cancelBtn: {
     width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center"
  },
  saveButtonCol:{
    display: "flex",
    justifyContent: "flex-end",
    height: "44px"
  },
  saveBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  }
}));

export default styles;
